<template>
  <div>
    <v-col id="bubble-chart" class="pt-0 pl-0" />
  </div>
</template>

<script>
import * as d3 from "d3";

export default {
  name: "BubbleChart",
  mounted() {
    this.generateBubbleChart();
  },
  props:{
    series:{
      type:Object,
      required:true
    }
  },
  methods: {
    generateBubbleChart() {
      var margin = {top: 40, right: 40, bottom: 60, left: 40},
          width = 800 - margin.left - margin.right,
          height = 300 - margin.top - margin.bottom;

      // append the svg object to the body of the page
      var svg = d3.select("#bubble-chart")
        .append("svg")
          .attr("width", width + margin.left + margin.right)
          .attr("height", height + margin.top + margin.bottom)
          .call(responsivefy)
        .append("g")
          .attr("transform",
                "translate(" + margin.left + "," + margin.top + ")");

      var f_series = []
      var sentimientos = {positives:"Positivos",negatives:"Negativos",neutres:"Neutros"}

      Object.keys(this.series).forEach((sentiment)=>{

        if (sentiment != "status") {
          Array.from(this.series[sentiment]).forEach((element) => {
            f_series.push({x: element.tweets ,y: element.retweets,z: element.followers, sentiment:sentimientos[sentiment], username: element.username})
          });
        }
      })
      // ---------------------------//
      //       AXIS  AND SCALE      //
      // ---------------------------//

      // Add X axis

      var xDom = {min: f_series[0].x,max: 0}
      var yDom = {min: f_series[0].y,max: 0}
      var zDom = {min: f_series[0].z,max: 0}

      f_series.forEach(element => {
        if (Number(element.x)<xDom.min){
          xDom.min=Number(element.x)
        }
        if (Number(element.x)>xDom.max){
          xDom.max=Number(element.x)
        }
        if (Number(element.y)<yDom.min){
          yDom.min=Number(element.y)
        }
        if (Number(element.y)>yDom.max){
          yDom.max=Number(element.y)
        }
        if (Number(element.z)<zDom.min){
          zDom.min=Number(element.z)
        }
        if (Number(element.z)>zDom.max){
          zDom.max=Number(element.z)
        }
      });

      var x = d3.scaleLinear()
        .domain([xDom.min-xDom.max*0.05, xDom.max*1.05])
        .range([ 0, width ]);
      var xAxisGenerator = d3.axisBottom(x)
        .ticks(3)
        .tickSizeOuter(-width)
        .tickSize(0)

      let xAxis = svg.append("g")
        .attr("transform", "translate(0," + height + ")")
        .call(xAxisGenerator);

      xAxis.select(".domain")
        .attr("stroke-width","0")

      // Add X axis label:
      svg.append("text")
          .attr("text-anchor", "end")
          .attr("x", width)
          .attr("y", height+10 )
          .text("Tweets");

      // Add Y axis
      var y = d3.scaleLinear()
        .domain([yDom.min-yDom.max*0.1,yDom.max*1.05])
        .range([ height, 0]);

      var yAxisGenerator = d3.axisLeft(y)
      .tickSizeOuter(-width)
      .tickSize(-width);

      let yAxis = svg.append("g")
        .call(yAxisGenerator);

      yAxis.selectAll(".tick line")
        .style("opacity", 0.2)

      yAxis.select(".domain")
        .attr("stroke-width","0")

      // Add Y axis label:
      svg.append("text")
          .attr("text-anchor", "end")
          .attr("x", 0)
          .attr("y", -5 )
          .text("Retweets")
          .attr("text-anchor", "start")

      // Add a scale for bubble size
      var z = d3.scaleSqrt()
        .domain([zDom.min,zDom.max])
        .range([ 3, 20]);

      // Add a scale for bubble color
      const colores = {Positivos:'#00E396',Negativos:'#FF4560',Neutros:'#FEB019'}
      var myColor = (sentiment)=>{
        return colores[sentiment];
      }



      // ---------------------------//
      //      TOOLTIP               //
      // ---------------------------//

      // -1- Create a tooltip div that is hidden by default:
      var tooltip = d3.select("#bubble-chart")
        .append("div")
          .style("opacity", 0)
          .attr("class", "tooltip")
          .style("background-color", "black")
          .style("border-radius", "5px")
          .style("padding", "10px")
          .style("color", "white")

      // -2- Create 3 functions to show / update (when mouse move but stay on same circle) / hide the tooltip
      var showTooltip = function(d) {
        tooltip
          .transition()
          .duration(200)
        tooltip
          .style("opacity", 1)
          .html("<b>" + d.originalTarget.__data__.username+"</b><br/>"+"Tweets: " + d.originalTarget.__data__.x+"<br/>"+"Retweets: " + d.originalTarget.__data__.y+"<br/>"+"Followers: " + d.originalTarget.__data__.z+"<br/>")
          .style("top", (d.layerY-20) + "px")
          .style("left", (d.layerX) + "px")
      }
      var moveTooltip = function(d) {
        tooltip
          .style("top", (d.layerY-20) + "px")
          .style("left", (d.layerX) + "px")
      }
      var hideTooltip = function() {
        tooltip
          .transition()
          .duration(200)
          .style("opacity", 0)
      }


      // ---------------------------//
      //       HIGHLIGHT GROUP      //
      // ---------------------------//

      // What to do when one group is hovered
      var highlight = function(d){
        // reduce opacity of all groups
        d3.selectAll(".bubbles").style("opacity", .05)
        // expect the one that is hovered
        d3.selectAll("."+d.explicitOriginalTarget.data).style("opacity", 1)
      }

      // And when it is not hovered anymore
      var noHighlight = function(){
        d3.selectAll(".bubbles").style("opacity", 1)
      }


      // ---------------------------//
      //       CIRCLES              //
      // ---------------------------//

      // Add dots
      svg.append('g')
        .selectAll("dot")
        .data(f_series)
        .enter()
        .append("circle")
          .attr("class", function(d) { return "bubbles " + d.sentiment })
          .attr("cx", function (d) { return x(d.x); } )
          .attr("cy", function (d) { return y(d.y); } )
          .attr("r", function (d) { return z(d.z); } )
          .style("fill", function (d) { return myColor(d.sentiment); } )
        // -3- Trigger the functions for hover
        .on("mouseover", showTooltip )
        .on("mousemove", moveTooltip )
        .on("mouseleave", hideTooltip )




        // ---------------------------//
        //       LEGEND              //
        // ---------------------------//

        // Add one dot in the legend for each name.
        var allgroups = ["Positivos", "Negativos", "Neutros"]

        var nodeWidth = (d) => d.getBBox().width;
        const legend = svg.append('g')
          .attr('class', 'legend')
          .attr('transform', 'translate(0,0)');

        const lg = legend.selectAll('g')
          .data(allgroups)
          .enter()
        .append('g')
          .attr('transform', (d,i) => `translate(${i * 100},${height + 25})`);

        lg.append('circle')
          .style('fill', d => myColor(d))
          .attr('cx', 0)
          .attr('cy', 5)
          .attr('r', 7)
          .attr('width', 10)
          .attr('height', 10)
          .on("mouseover", highlight)
          .on("mouseleave", noHighlight);

        lg.append('text')
          .style('font-family', 'Helvetica')
          .style('font-size', '13px')
          .attr('x', 17.5)
          .attr('y', 10)
          .text(d => d)
          .on("mouseover", highlight)
          .on("mouseleave", noHighlight);

        let offset = 0;
        lg.attr('transform', function() {
            let x = offset;
            offset += nodeWidth(this) + 10;
            return `translate(${x},${height + 20})`;
        });

        legend.attr('transform', function() {
          return `translate(${(width - nodeWidth(this)) / 2},${0})`
        });

        function responsivefy(svg) {

            const container = d3.select(svg.node().parentNode),
                width = parseInt(svg.style('width'), 10),
                height = parseInt(svg.style('height'), 10),
                aspect = width / height;

            // Add viewBox attribute to set the value to initial size
            // add preserveAspectRatio attribute to specify how to scale
            // and call resize so that svg resizes on page load
            svg.attr('viewBox', `0 0 ${width} ${height}`).
            attr('preserveAspectRatio', 'xMinYMid').
            call(resize);

            d3.select(window).on('resize.' + container.attr('id'), resize);

            function resize() {
                const targetWidth = parseInt(container.style('width'));
                svg.attr('width', targetWidth);
                svg.attr('height', Math.round(targetWidth / aspect));
            }
        }
    }
  },
  watch:{
    series(){
      this.generateBubbleChart();
    }
  },
};
</script>

<style>
.subunits {
  fill: #cdd;
}
div.tooltip {
    position: absolute;
    text-align: center;
    padding: 2px;
    font: 12px sans-serif;
    background: lightsteelblue;
    border: 0px;
    border-radius: 8px;
    pointer-events: none;
}
</style>
